import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { LocalStorage } from '../../../shared/services/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorage)
  const accessToken = localStorageService.getDataByKey('accessToken')
  const isApiUrl = req.url.startsWith(environment.API_BASE_URL);
  const router = inject(Router);
  if (accessToken && isApiUrl) {
    // Clone the request to add the Authorization header
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
    });
  }

  return next(req).pipe(
    catchError((err) => {
      console.error('err', err);

      if (err.status === 401) {
        localStorageService.clearAllStorage()
        router.navigate(['']);
      }
      throw err;
    })
  )
};
